import { Box } from '@lifeomic/chroma-react/components/Box';
import { Button } from '@lifeomic/chroma-react/components/Button';
import { Modal } from '@lifeomic/chroma-react/components/Modal';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  note: {
    color: theme.palette.text.hint,
    marginTop: theme.spacing(2),
  },
}));

const messages = defineMessages({
  title: {
    id: 'actionPlan.regenerateCoachingModal.title',
    defaultMessage: 'Regenerate coaching',
  },
  scope: {
    id: 'actionPlan.regenerateCoachingModal.scope',
    defaultMessage: 'Only Zori Coaching will be regenerated.',
  },
  description: {
    id: 'actionPlan.regenerateCoachingModal.description',
    defaultMessage:
      'A new coaching snapshot will be created from current member data.',
  },
  unchanged: {
    id: 'actionPlan.regenerateCoachingModal.unchanged',
    defaultMessage: 'Other Zori Pulse results will not change.',
  },
  note: {
    id: 'actionPlan.regenerateCoachingModal.note',
    defaultMessage: 'This may take a few minutes to complete.',
  },
  cancel: {
    id: 'actionPlan.regenerateCoachingModal.cancel',
    defaultMessage: 'Cancel',
  },
  regenerate: {
    id: 'actionPlan.regenerateCoachingModal.regenerate',
    defaultMessage: 'Regenerate coaching',
  },
});

export type RegenerateCoachingModalProps = {
  isOpen: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  disabled?: boolean;
};

export const RegenerateCoachingModal: React.FC<
  RegenerateCoachingModalProps
> = ({ isOpen, onDismiss, onConfirm, disabled = false }) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();

  const handleRegenerate = () => {
    onConfirm();
    onDismiss();
  };

  return (
    <Modal
      title={formatMessage(messages.title)}
      isOpen={isOpen}
      onDismiss={onDismiss}
      size={1}
      actions={
        <>
          <Button
            onClick={onDismiss}
            variant="outlined"
            color="negative"
            fullWidth
          >
            {formatMessage(messages.cancel)}
          </Button>
          <Button onClick={handleRegenerate} fullWidth disabled={disabled}>
            {formatMessage(messages.regenerate)}
          </Button>
        </>
      }
    >
      <Box direction="column" gap={1.5}>
        <Text weight="bold">{formatMessage(messages.scope)}</Text>
        <Text>{formatMessage(messages.description)}</Text>
        <Text>{formatMessage(messages.unchanged)}</Text>
        <Text size="caption" className={classes.note}>
          {formatMessage(messages.note)}
        </Text>
      </Box>
    </Modal>
  );
};
